exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".arrow-icon--right[data-v-40bc3bd8]{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.arrow-icon--bottom[data-v-40bc3bd8]{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.arrow-icon--left[data-v-40bc3bd8]{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.arrow-icon--top[data-v-40bc3bd8]{-webkit-transform:rotate(270deg);transform:rotate(270deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40bc3bd8","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/common/icon/ArrowIcon.vue
// module id = QYDn
// module chunks = 0 2